var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26184 9.88879C5.40104 9.94159 4.66664 9.29359 4.61144 8.43919C4.56024 7.58399 5.20504 6.84479 6.06744 6.79039C6.91944 6.73599 7.65224 7.38879 7.70664 8.24319C7.76184 9.09839 7.11464 9.83599 6.26184 9.88879ZM20.5568 7.5856C19.552 6.5688 17.8912 6.7448 16.912 7.7824C15.6376 9.12 14.6464 9.62 13.4648 9.5704C11.8168 9.4984 11.0032 8.2232 10.1576 6.6152C9.2784 4.936 7.9256 4 6.24 4C3.5888 4 2 6.1464 2 8.54C2 12.2232 4.5896 14.4248 6.3824 15.3528C7.872 16.1296 9.5288 16.4528 11.0032 16.4904C10.916 17.3704 10.6568 18.5328 10.3712 19.356H10.5224H11.8984H13.2728H13.4032C13.1048 18.5328 12.84 17.2744 12.7584 16.392C17.2008 15.8152 19.3112 13.7984 20.4664 11.8776C20.9848 11.0344 21.2616 10.1592 21.2584 9.3728C21.2544 8.684 21.0352 8.0576 20.5568 7.5856Z",
    fill: "#6EB329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/교보증권-24.402fb5430c9e1821f7ba2c69d4027503.svg";
export { ForwardRef as ReactComponent };